"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartTradeMarketProcessor = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const TextAndSliderSyncTool_1 = require("../CommonUtils/TextAndSliderSyncTool");
exports.SmartTradeMarketProcessor = {
    useUserParams: (invest, investPercent, investActionType, trailingPercentText, quoteAvailable, symbol, currentPrice, orderType) => {
        const balance = (0, react_1.useMemo)(() => {
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(quoteAvailable, symbol.precision);
        }, [symbol, quoteAvailable]);
        const [parseInvest, parseInvestPercent] = TextAndSliderSyncTool_1.TextAndSliderSyncTool.useGridInvestAndInvestPercent(investActionType, invest, investPercent, balance, symbol.precisionCost);
        const [minCost, maxCost] = (0, react_1.useMemo)(() => {
            var _a, _b, _c;
            const limitMax = ((_a = symbol.limit) === null || _a === void 0 ? void 0 : _a.spending.max) ? symbol.limit.spending.max : undefined;
            let max = balance;
            if (limitMax) {
                const tempMax = trade_utils_lib_1.SafeDecimal.min(new trade_utils_lib_1.SafeDecimal(limitMax), new trade_utils_lib_1.SafeDecimal(balance));
                max = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(tempMax, symbol.precisionCost);
            }
            let min = undefined;
            const limitMin = (_b = symbol.limit) === null || _b === void 0 ? void 0 : _b.spending.min;
            const minAmount = (_c = symbol.limit) === null || _c === void 0 ? void 0 : _c.dumping.min;
            if (limitMin && minAmount) {
                const tempMin = trade_utils_lib_1.SafeDecimal.max(new trade_utils_lib_1.SafeDecimal(minAmount).mul(new trade_utils_lib_1.SafeDecimal(currentPrice)), new trade_utils_lib_1.SafeDecimal(limitMin)).mul(1.05);
                min = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(tempMin, symbol.precisionCost, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
            }
            return [min, max];
        }, [symbol, balance, currentPrice]);
        const investState = (0, react_1.useMemo)(() => {
            const state = {
                state: "normal",
                min: minCost || "",
                max: maxCost || ""
            };
            if (parseInvest) {
                if (new trade_utils_lib_1.SafeDecimal(parseInvest).lessThan(new trade_utils_lib_1.SafeDecimal(minCost))) {
                    state.state = 'small';
                }
                if (new trade_utils_lib_1.SafeDecimal(parseInvest).greaterThan(new trade_utils_lib_1.SafeDecimal(maxCost))) {
                    state.state = 'large';
                }
            }
            return state;
        }, [minCost, maxCost, parseInvest, symbol.symbol]);
        const emptyErrors = (0, react_1.useMemo)(() => {
            const emptys = [];
            if (!Number(parseInvest)) {
                emptys.push("trading_total_investment");
            }
            if (!Number(trailingPercentText)) {
                emptys.push("trailing_stop_limit_place_holder_trailing_percent");
            }
            return emptys;
        }, [parseInvest, trailingPercentText]);
        return {
            invest: parseInvest, investPercent: parseInvestPercent, investState, trailingPercentText, balance,
            symbol, orderType, minCost, maxCost, emptyErrors
        };
    },
    getCreateOrderRequest: (params, ticker, $st) => {
        var _a;
        const { symbol } = params;
        if (params.emptyErrors.length > 0) {
            throw $st("trade_params_not_fill_enough");
        }
        if (params.investState.state === "small") {
            throw $st("trade_error_low_amount", {
                amount: `${params.minCost} ${symbol.quote}`
            });
        }
        else if (params.investState.state === "large") {
            if (new trade_utils_lib_1.SafeDecimal(params.invest).greaterThan(new trade_utils_lib_1.SafeDecimal(params.balance))) {
                throw $st("trade_error_balance_not_enough");
            }
            throw $st("trade_error_high_cost", { cost: `${params.investState.max} ${symbol.quote}` });
        }
        const maxDumping = (_a = params.symbol.limit) === null || _a === void 0 ? void 0 : _a.dumping.max;
        if (Number(ticker.latest) && maxDumping) {
            // 预期最大购买量. 放大系数: 1.2
            const esAmount = new trade_utils_lib_1.SafeDecimal(params.invest).div(new trade_utils_lib_1.SafeDecimal(ticker.latest)).mul(1.2);
            if (esAmount.greaterThan(new trade_utils_lib_1.SafeDecimal(maxDumping))) {
                const maxI = new trade_utils_lib_1.SafeDecimal(maxDumping).div(1.2).mul(new trade_utils_lib_1.SafeDecimal(ticker.latest));
                const finalMaxI = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(maxI, symbol.precisionCost);
                throw $st("smart_trade_market_error_symbol_max_dumping", { max: `${finalMaxI} ${symbol.quote}` });
            }
        }
        const trailingPercent = new trade_utils_lib_1.SafeDecimal(params.trailingPercentText).div(100);
        if (trailingPercent.lessThanOrEqualTo(0) || trailingPercent.greaterThanOrEqualTo(1)) {
            throw $st("trade_trailing_percent_range_error", { min: "0%", max: "100%" });
        }
        return {
            type: params.orderType,
            smart_type: TradeAPILib_1.SmartTradeType.smart_trade,
            base: symbol.base,
            quote: symbol.quote,
            buy: "0",
            trigger: "0",
            amount: params.invest,
            trailing_percentage: trailingPercent.toString(),
            loss_stop: "0"
        };
    }
};
